// All content mocked from source site (marbellaconsulting.eu) for frontend-only build.

export const ASSETS = {
  logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_marbella-port/artifacts/sjcmgmox_marbella-logo-header.png",
  brandBanner:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_marbella-port/artifacts/5e7adf157804b0ae_1789432317400.png",
  heroBanner:
    "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/0sp4tdxc_marbella-banner.png",
  founder: "/founder-photo.jpg",
  summerGift:
    "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/guf3msux_ChatGPT%20Image%20Aug%2026%2C%202026%2C%2004_02_28%20PM.png",
  revolutQr: "https://customer-assets-4nw71qhi.emergentagent.net/job_marbella-port/artifacts/lmxbyhqn_revolut-qr.png",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Properties", href: "#properties" },
  { label: "Concierge", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const MARQUEE_ITEMS = [
  "Luxury Real Estate",
  "Investment Consulting",
  "Holiday Rentals",
  "Yacht Charters",
  "Private Chefs",
  "Chauffeur Services",
  "Bespoke Itineraries",
  "Costa del Sol",
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Property & Investment",
    text: "Luxury real estate sales, investment consulting and short-term holiday rentals across Marbella's most coveted addresses, from the Golden Mile to La Zagaleta.",
  },
  {
    num: "02",
    title: "Bespoke Concierge",
    text: "Accommodation booking, airport transfers, chauffeurs, private chefs, wellness and fine dining, with every detail curated before you arrive.",
  },
  {
    num: "03",
    title: "Lifestyle & Leisure",
    text: "From private family experiences and luxury day trips to exclusive celebrations and bespoke itineraries, every moment is designed to be unforgettable.",
  },
];

export const SERVICES = [
  {
    icon: "umbrella",
    span: 7,
    title: "Lifestyle & Leisure",
    image:
      "https://images.pexels.com/photos/17929164/pexels-photo-17929164.jpeg?auto=compress&cs=tinysrgb&w=1200",
    items: [
      "Restaurant, beach club & golf reservations",
      "Shopping & personal assistance",
      "Curated recommendations",
    ],
  },
  {
    icon: "utensils-crossed",
    span: 5,
    title: "Wellness & Dining",
    image:
      "https://images.pexels.com/photos/4253315/pexels-photo-4253315.jpeg?auto=compress&cs=tinysrgb&w=1200",
    items: [
      "Personal trainers",
      "Private chefs",
      "Middle Eastern & international fine dining, events",
    ],
  },
  {
    icon: "plane",
    span: 5,
    title: "Luxury Travel",
    image:
      "https://images.unsplash.com/photo-1758384076382-21f6587e1048?auto=format&fit=crop&w=1200&q=80",
    items: ["Airport transfers", "Chauffeur services", "Yacht charters"],
  },
  {
    icon: "building-2",
    span: 7,
    title: "Accommodation",
    image:
      "https://images.pexels.com/photos/29334668/pexels-photo-29334668.png?auto=compress&cs=tinysrgb&w=1200",
    items: [
      "Accommodation booking services",
      "Short-term holiday rentals",
      "Pre-arrival preparation",
    ],
  },
];

export const FLEET = [
  {
    title: "Mercedes S-Class",
    seats: "4 Seats",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cd9f37ca-77d8-472a-ac4d-08f953d72af7/images/8ba4053efd1c914f6dd08101aae89eaca2dffb23af30f2b2fea7e872cc8c0e21.jpeg",
  },
  {
    title: "Mercedes V-Class",
    seats: "7 Seats",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cd9f37ca-77d8-472a-ac4d-08f953d72af7/images/29bb8aa4cab5e61131be5b6ca243dd2579925f436f1f87f00115d9d8e2aaa978.jpeg",
  },
  {
    title: "Mercedes Sprinter VIP",
    seats: "10 Seats",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cd9f37ca-77d8-472a-ac4d-08f953d72af7/images/3df70bc12c75362b50e7884b5d83aef428d7d8a98a9c29e92f3a6a9cc9719a98.jpeg",
  },
];

export const TRANSFER_POINTS = [
  "Established Company",
  "Luxury · Professional · Reliable",
  "Specialized in GCC & International Clients",
  "Private Transfers from Málaga Airport to Marbella, Benahavís & Estepona",
];

export const EXPERIENCES = [
  {
    caption: "Marbella Club Hotel",
    alt: "Charming Marbella old town restaurant terrace",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/57wt6w0p_Querido%20Hotels.jpg",
  },
  {
    caption: "Marbella Old Town",
    alt: "Stylish open-air dining patio in Marbella",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/zjnwdsva_ELLE.webp",
  },
  {
    caption: "Puente Romano",
    alt: "Historic stone bridge at Puente Romano",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/hj3dbpc7_Puente%20Romano%20Real%20Estate.jpg",
  },
  {
    caption: "Casanis Group sigue creciendo",
    alt: "Casanis bistrot restaurant terrace in Marbella old town",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/q1ti3hvy_Image_20260915_210033_666.webp",
  },
  {
    caption: "Rodman 48",
    alt: "Luxury yacht cruising the Mediterranean",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/g1jt9vnh_Rodman%2048.jpg",
  },
  {
    caption: "Mamzel Marbella",
    alt: "Evening dining terrace under palm trees in Marbella",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/cnaufmoz_Vacation%20Marbella.jpeg",
  },
  {
    caption: "Marbella Club MC Beach",
    alt: "Beachfront dining with turquoise sea views",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/z1jq2i1f_CHIRINGUITO-BLUE-IBIZA.webp",
  },
  {
    caption: "Starlite Festival",
    alt: "Starlite Festival open-air concert in Marbella",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/km57ngc3_Starlite%20festival.webp",
  },
  {
    caption: "The Trocadero Estepona",
    alt: "Trocadero Estepona beachfront pool and restaurant",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/ykq7frvs_Trocadero%20Estepona.jpg",
  },
  {
    caption: "Marbella Club Hotel",
    alt: "Marbella Club Hotel beach with pine trees and mountains",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/759ex0xm_Marbella%20Club%20Hotel.jpg",
  },
  {
    caption: "Ocean Club Marbella",
    alt: "Ocean Club Marbella pool deck with white daybeds",
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_premium-estates-63/artifacts/cgbkjb14_Ocean-Club-Marbella.jpg",
  },
];

export const PROPERTIES = [
  {
    title: "Marine Hills by TM",
    location: "Estepona / Selwo",
    desc: "Apartments · Penthouses · Villas · Sea & Nature Views",
    price: "On Request",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cd9f37ca-77d8-472a-ac4d-08f953d72af7/images/f76a8a728055c0a84ce1a8aec61eccc1f2a725480cb1d60b3e8581444d7ac471.jpeg",
  },
  {
    title: "Metrovacesa, S.A. Development",
    location: "Marbella / Costa del Sol",
    desc: "Exclusive Off-Plan Development · Premium Residences",
    price: "On Request",
    image:
      "https://static.prod-images.emergentagent.com/jobs/cd9f37ca-77d8-472a-ac4d-08f953d72af7/images/b4b53e345dab8666ddc9cb4e4f70fa7b8dbf0ce6878446d531f270b140a5fac6.jpeg",
  },
  {
    title: "Bel Air, Marbella",
    location: "New Golden Mile",
    desc: "Ground Floor Apartment · Fully Furnished · Ready to Move In",
    price: "€540,000",
    image: "/belair/terrace.jpg",
    link: "#bel-air",
  },
];

export const BELAIR = {
  price: "€540,000",
  flyer: "/belair/flyer.jpg",
  hero: "/belair/terrace.jpg",
  gallery: [
    { src: "/belair/living.jpg", key: "living" },
    { src: "/belair/kitchen.jpg", key: "kitchen" },
    { src: "/belair/bedroom.jpg", key: "bedroom" },
    { src: "/belair/garden.jpg", key: "garden" },
    { src: "/belair/pool.jpg", key: "pool" },
  ],
  specs: [
    { icon: "BedDouble", value: "2", en: "Bedrooms", es: "Dormitorios" },
    { icon: "Bath", value: "2", en: "Bathrooms", es: "Baños" },
    { icon: "Home", value: "90 m²", en: "Built Size", es: "Construidos" },
    { icon: "Umbrella", value: "55 m²", en: "Terrace", es: "Terraza" },
    { icon: "Sprout", value: "42 m²", en: "Garden / Plot", es: "Jardín / Parcela" },
    { icon: "Car", value: "2", en: "Garage Spaces + Storage", es: "Plazas de garaje + trastero" },
  ],
  en: {
    eyebrow: "Featured Listing · Ground Floor Apartment",
    tagline: "In the heart of the New Golden Mile",
    badge: "Fully Furnished · Ready to Move In",
    pillars: "Luxury · Comfort · Prime Location",
    descTitle: "Located in the heart of the New Golden Mile",
    desc: "Strategically located in Bel Air, in the heart of the New Golden Mile, within walking distance to the beach, all amenities, services, and the town of Cancelada, with easy access to both Puerto Banús and Estepona.",
    quote: "The perfect home on the Costa del Sol",
    featuresTitle: "Features",
    features: ["Communal pools", "Gardens & jacuzzis", "Children's area", "Underfloor heating", "Aerothermy heating", "Wide terraces & garden", "South orientation"],
    galleryLabels: { living: "Living & Dining", kitchen: "Kitchen", bedroom: "Master Bedroom", garden: "Private Garden", pool: "Communal Pool" },
    priceLabel: "Price",
    price: "€540,000",
    enquire: "Enquire on WhatsApp",
    viewFlyer: "View full flyer",
    waText: "Hello, I am interested in the Bel Air 2-bedroom apartment (€540,000).",
  },
  es: {
    eyebrow: "Propiedad destacada · Apartamento en planta baja",
    tagline: "En el corazón de la Nueva Milla de Oro",
    badge: "Totalmente amueblado · Listo para entrar a vivir",
    pillars: "Lujo · Confort · Ubicación privilegiada",
    descTitle: "En el corazón de la Nueva Milla de Oro",
    desc: "Estratégicamente situado en Bel Air, en el corazón de la Nueva Milla de Oro, a poca distancia a pie de la playa, todos los servicios y el pueblo de Cancelada, con fácil acceso a Puerto Banús y Estepona.",
    quote: "El hogar perfecto en la Costa del Sol",
    featuresTitle: "Características",
    features: ["Piscinas comunitarias", "Jardines y jacuzzis", "Zona infantil", "Suelo radiante", "Calefacción por aerotermia", "Amplias terrazas y jardín", "Orientación sur"],
    galleryLabels: { living: "Salón y comedor", kitchen: "Cocina", bedroom: "Dormitorio principal", garden: "Jardín privado", pool: "Piscina comunitaria" },
    priceLabel: "Precio",
    price: "€540.000",
    enquire: "Consultar por WhatsApp",
    viewFlyer: "Ver folleto completo",
    waText: "Hola, me interesa el apartamento de 2 dormitorios en Bel Air (€540.000).",
  },
};

export const WHY_US = [
  {
    num: "01",
    title: "Local Mastery",
    text: "Deep roots in Marbella and the Costa del Sol, with privileged access to off-market properties and the region's finest addresses.",
  },
  {
    num: "02",
    title: "One Discreet Point of Contact",
    text: "Property, investment and lifestyle handled by a single trusted consultancy, with absolute discretion.",
  },
  {
    num: "03",
    title: "International Clientele",
    text: "Multilingual service tailored to clients from the Middle East, Europe and beyond, including Middle Eastern fine dining and cultural fluency.",
  },
  {
    num: "04",
    title: "End to End",
    text: "From the first viewing to the last sunset dinner reservation, every detail is anticipated and arranged.",
  },
];

export const FEES = [
  {
    icon: "house",
    label: "Accommodation booked through Marbella Consulting",
    price: "€250",
    unit: "per person / week",
  },
  {
    icon: "concierge-bell",
    label: "Daily concierge service",
    price: "€50",
    unit: "per person / per day",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "From the moment we landed, everything simply happened. The villa, the chef, the yacht. Marbella Consulting anticipated it all.",
    name: "James & Olivia Whitmore",
    location: "London, United Kingdom",
  },
  {
    quote:
      "They found us an off-market property on the Golden Mile within three weeks. Discreet, precise, and remarkably well connected.",
    name: "Khalid Al Rashid",
    location: "Dubai, UAE",
  },
  {
    quote:
      "Our family summer in Marbella was flawless, with private trainers each morning, beach clubs at noon and fine dining every evening.",
    name: "Sofia Lindqvist",
    location: "Stockholm, Sweden",
  },
];

export const FAQ = [
  {
    q: "What areas do you cover?",
    a: "We specialise in Marbella and the wider Costa del Sol, including the New Golden Mile, Estepona, Sierra Blanca, Puente Romano, Nueva Andalucía, La Zagaleta and Puerto Banús.",
  },
  {
    q: "How do your concierge fees work?",
    a: "If your accommodation is booked through Marbella Consulting, the concierge fee is €250 per person per week. If booked independently, the fee is €50 per person, per day. Daily concierge service is also available on request.",
  },
  {
    q: "Can you assist with property investment as a non-resident?",
    a: "Absolutely. We guide international clients through the full acquisition process, including legal, fiscal and financing considerations, with trusted local partners.",
  },
  {
    q: "Do you manage short-term holiday rentals?",
    a: "Yes. We source, prepare and manage premium holiday rentals, and can pair your stay with full concierge support from airport transfer to departure.",
  },
  {
    q: "What languages do you serve clients in?",
    a: "Our team serves an international clientele in English, Spanish, Arabic and the Persian language, with particular expertise in Middle Eastern and European client needs.",
  },
];

export const INTEREST_OPTIONS = [
  "Property Purchase",
  "Investment Consulting",
  "Holiday Rental",
  "Concierge Services",
  "Other",
];

export const CONTACT = {
  phone: "+34 610 66 69 00",
  phoneHref: "tel:+34610666900",
  instagram: "@marbella_consulting",
  instagramHref: "https://www.instagram.com/marbella_consulting/",
  location: "Marbella, Costa del Sol, Spain",
  whatsapp: "https://wa.me/34610666900",
};
